import { http } from '@/shared/api/axios'
import {
  OfficeClockStatusSchema,
  OfficeTimeEntrySchema,
  parseOfficeTimeList,
  type CreateOfficeTimeRequest,
  type ListOfficeTimeParams,
  type OfficeClockRequest,
  type OfficeClockStatus,
  type OfficeTimeEntry,
  type UpdateOfficeTimeRequest,
} from '../model/types'

const BASE = '/v1/office-time'
const QUIET = { _skipErrorToast: true } as never

export async function fetchOfficeClockStatus(): Promise<OfficeClockStatus> {
  const { data } = await http.get(`${BASE}/me/current`, QUIET)
  return OfficeClockStatusSchema.parse(data ?? {})
}

export async function clockInToOffice(body: OfficeClockRequest): Promise<OfficeTimeEntry> {
  const { data } = await http.post(`${BASE}/me/clock-in`, body, QUIET)
  return OfficeTimeEntrySchema.parse(data)
}

export async function clockOutOfOffice(body: OfficeClockRequest): Promise<OfficeTimeEntry> {
  const { data } = await http.post(`${BASE}/me/clock-out`, body, QUIET)
  return OfficeTimeEntrySchema.parse(data)
}

export async function fetchOfficeTime(params: ListOfficeTimeParams): Promise<OfficeTimeEntry[]> {
  const { data } = await http.get(BASE, { params, _skipErrorToast: true } as never)
  return parseOfficeTimeList(data)
}

export async function createOfficeTime(body: CreateOfficeTimeRequest): Promise<OfficeTimeEntry> {
  const { data } = await http.post(BASE, body, QUIET)
  return OfficeTimeEntrySchema.parse(data)
}

export async function updateOfficeTime(id: number, body: UpdateOfficeTimeRequest): Promise<OfficeTimeEntry> {
  const { data } = await http.put(`${BASE}/${id}`, body, QUIET)
  return OfficeTimeEntrySchema.parse(data)
}

export async function deleteOfficeTime(id: number): Promise<void> {
  await http.delete(`${BASE}/${id}`, QUIET)
}
